import icon from "../../assets/uplink.svg";
import type { Property } from "../../types";

export const uplink: Property = {
  id: "uplink",
  title: "uplink.title",
  icon,
};
